import React from 'react'

const Outlook = ({ size = 24, color = '#3076D0', ...props }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		{...props}
	>
		<path
			d="M2 4.25352V19.5587L13.7718 22V2L2 4.25352ZM7.93071 15.4655C4.18849 15.2268 4.57391 8.55516 8.01807 8.50215C11.7077 8.74336 11.3458 15.4123 7.93071 15.4655ZM7.98466 9.80844C6.01315 9.94383 6.10142 14.1212 7.95425 14.1547C9.91726 14.0296 9.80198 9.8409 7.98466 9.80844ZM15.7776 12.4691C15.9554 12.5983 16.1695 12.4691 16.1695 12.4691C15.9561 12.5983 22 8.62762 22 8.62762V15.8179C22 16.6005 21.4934 16.9288 20.9238 16.9288H14.5154L14.5158 11.612L15.7776 12.4691ZM14.5161 6.24039V10.1525L15.8983 11.0133C15.9348 11.0239 16.0138 11.0246 16.0502 11.0133L21.9992 7.04637C21.9992 6.57691 21.5564 6.24039 21.3065 6.24039H14.5161Z"
			fill={color}
		/>
	</svg>
)

export default Outlook;
